/**
 * Exercise / competency badge mark.
 * Brand color comes from the CSS tile behind the PNG; the asset itself keeps
 * true pictogram colors and a punchable neutral plate (not hue-shifted).
 */
export function ExerciseTypeMark({ src }) {
  return <img src={src} alt="" draggable={false} />;
}
